import { useMemo } from "react";

/**
 * Derive API sort params + stable DataGrid sort props from useGridLayout.
 * Avoids inline fallback arrays in JSX that fight MUI controlled sortModel.
 */
export default function useServerGridSort(layout, defaultField, defaultDir = "asc") {
    const defaultSort = useMemo(
        () => [{ field: defaultField, sort: defaultDir === "desc" ? "desc" : "asc" }],
        [defaultField, defaultDir]
    );

    const sortModel =
        layout.sortModel?.length > 0 ? layout.sortModel : defaultSort;

    const sortForApi = useMemo(() => {
        const entry = sortModel[0];
        return {
            sort: entry.field,
            sortDir: entry.sort === "asc" ? "asc" : "desc",
        };
    }, [sortModel]);

    const onSortModelChange = (model) => {
        layout.onSortModelChange(model?.length ? model : defaultSort);
    };

    return { sortModel, sortForApi, onSortModelChange, defaultSort };
}
